import { render } from "./AutoComplete.vue?vue&type=template&id=3e2bc4c1"
import script from "./AutoComplete.vue?vue&type=script&lang=js"
export * from "./AutoComplete.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniokatarov/PhpstormProjects/WEBIS WHS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__